import React from "react";

export const DOP = 58.5;

// Shipping rates — store-predetermined prices (USD).
// GSD = Gran Santo Domingo: Distrito Nacional, SD Este/Norte/Oeste.
export const SHIPPING_RATES = {
  standard_gsd_usd: 200 / DOP,        // ~RD$200 standard delivery in Greater Santo Domingo
  express_local_usd: 300 / DOP,       // ~RD$300 in-area express (NutriMart messenger)
  express_free_min_usd: 50,           // Free express if cart subtotal ≥ $50 (store-eligible)
  national_caribepack_usd: 450 / DOP, // ~RD$450 nationwide via CaribePack
};

export const L = (o, lg) => typeof o === "object" && o !== null && !Array.isArray(o) ? (lg in o ? o[lg] : 'en' in o ? o.en : o) : (o ?? "");

// Force en-US grouping so we always render "RD$1,667" (no thin/non-breaking
// space artifacts that some browsers produce for the "es-DO" locale).
export const fp = (usd, lg) => lg === "es" ? `RD$${Math.round(usd * DOP).toLocaleString("en-US")}` : `$${usd.toFixed(2)}`;

// Centralized DOP formatter for values already stored in DOP (no conversion).
// Use this anywhere you need to render a raw DOP price (admin grids, CSVs, etc.)
// to avoid scattering ad-hoc `RD$${...}` template strings.
export const fmtDop = (v: unknown): string => {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return `RD$${Math.round(n).toLocaleString("en-US")}`;
};

export const Stars = ({ r, s = 12 }) => (
  <span style={{ display: "inline-flex", gap: 1 }}>
    {[...Array(5)].map((_, i) => (
      <svg key={i} width={s} height={s} viewBox="0 0 24 24" fill={i < Math.floor(r) ? "#F59E0B" : "#DDD"}>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </span>
);